/**
 * _javascript.js
 * Display a message to JavaScript disabled browser.
 */

$(function() {
  'use strict';

  $(document).ready(function(){
    $('#javascript-disabled').remove();
  });

});
